import type { TimeFormat } from '../../../constants/timezone';
import { useTimezone } from '../../../hooks/use-timezone';
import { generateTimeOptions } from '../utils/time';

export function useTimeRangeOptions(
  startHour: number,
  endHour: number,
  intervalMinutes: number = 30,
  labelTimeFormatOverride?: TimeFormat,
) {
  const { timeFormat } = useTimezone();
  const labelFormat = labelTimeFormatOverride ?? timeFormat;

  return generateTimeOptions(startHour, endHour, intervalMinutes, labelFormat);
}
